// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { brokeredPreviewStorage } from './previewAuthStorage';
import { previewAuthShimConfigFor } from '@/lib/preview-auth-shim';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

// Ephemeral preview builds sign in through the *dev* project and then mint a
// session on this project (docs/plans/PREVIEW_BRANCH_AUTH_SHIM.md), so the
// ?code= a preview lands on /auth with belongs to dev, not to us. With URL
// detection off, this client never tries to redeem another project's code.
// src/pages/Auth.tsx captures it first and src/components/PreviewAuthShim.tsx
// redeems it against dev. Unset (every other build) keeps the default.
const previewAuthShim =
  typeof window !== 'undefined' &&
  previewAuthShimConfigFor(window.location.hostname) !== null;

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: brokeredPreviewStorage(),
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: !previewAuthShim,
  }
});